import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import { UncontrolledTooltip } from "reactstrap";
import cx from "classnames";
import { ProductConfiguratorModal } from "objs/_ConfiguratorObjs/Wizard/ProductConfiguratorModal/ProductConfiguratorModal";
import { ProductListModal } from "components/_Modals/ProductListModal";
import { useTranslate } from "hooks";
import NiceModal from "@ebay/nice-modal-react";
import {
  usePossibleTopologyActions,
  useSubType,
  useTopology,
} from "objs/_ConfiguratorObjs/Wizard/stores/wizardStore";
import type { IOrderCode } from "interfaces/schemas/orderCode";
import type { Accessory } from "interfaces/schemas/accessories";
import type { IMenuItem } from "interfaces/schemas/topology";
import { Button } from "../Button";
import s from "./SummaryListItem.module.scss";

const actionsIconNames: Record<number, string> = {
  1: "configure-regular",
};

interface ISummaryListItemIconBtnProps {
  id: string;
  title: string;
  orderCode: IOrderCode;
  dummy: string;
  type: string;
  menuItem: IMenuItem;
  handleBackAction: () => void;
  selectedAccessories: Accessory[];
  groupPosition: number;
}

export const SummaryListItemIconBtn: React.FC<ISummaryListItemIconBtnProps> =
  Scrivito.connect(
    ({
      id,
      orderCode = {},
      dummy,
      type,
      menuItem,
      title,
      handleBackAction,
      selectedAccessories,
      groupPosition,
    }) => {
      const translate = useTranslate();

      const subType = useSubType();
      const topology = useTopology();
      const topologyActions = usePossibleTopologyActions();

      if (menuItem.enabled !== true) {
        return null;
      }

      if (!actionsIconNames[menuItem.id] || !topologyActions) {
        return null;
      }

      const { action, title: actionTitle } = topologyActions[menuItem.id];

      const handleClick = useCallback(() => {
        if (action === "configureComponent") {
          const isConfiguredProduct = orderCode.seriesId;

          NiceModal.show(
            isConfiguredProduct ? ProductConfiguratorModal : ProductListModal,
            {
              id,
              orderCode,
              title,
              dummy,
              wizardType: subType,
              type,
              handleBackAction,
              topology,
              selectedAccessories,
              groupPosition,
            },
          );
        }
      }, [
        action,
        orderCode,
        id,
        title,
        dummy,
        subType,
        type,
        handleBackAction,
        topology,
        selectedAccessories,
        groupPosition,
      ]);

      return (
        <div
          className={cx(
            "border-1 border-left border-gray-300 px-0.5 d-flex  justify-content-center w-5",
            s.item_list,
          )}
        >
          <Button
            data-testid={`${id}Icon`}
            square={true}
            color="tertiary"
            iconPrefix="trox"
            icon={actionsIconNames[menuItem.id]}
            iconClassName="icon-16"
            classNames="p-0 border-0 cursor-pointer bg-transparent"
            id={`IconTag-${id}`}
            onClick={handleClick}
          />
          {/* Item translation to be provided by b.e */}
          <UncontrolledTooltip target={`IconTag-${id}`} placement="top">
            {translate(actionTitle)}
          </UncontrolledTooltip>
        </div>
      );
    },
  );
